/**
 * Energy Matrix API Calls
 * Direct API calls for energy matrix endpoints
 */

import { publicRequest } from '../../../requestMeth';

/**
 * Get energy matrix summary for a period
 * @param {Object} params
 * @param {string} params.startDate - Start date (YYYY-MM-DD)
 * @param {string} params.endDate - End date (YYYY-MM-DD)
 * @param {string} params.compareStartDate - Optional comparison period start
 * @param {string} params.compareEndDate - Optional comparison period end
 * @param {string} params.mac - Optional MAC address(es) comma-separated
 * @param {string} token - Authorization token
 * @returns {Promise<Object>} Energy matrix summary
 */
export const getEnergyMatrixSummary = async (params, token) => {
  try {
    const queryParams = new URLSearchParams();

    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    if (params.compareStartDate) queryParams.append('compareStartDate', params.compareStartDate);
    if (params.compareEndDate) queryParams.append('compareEndDate', params.compareEndDate);
    if (params.primaryGroupId) queryParams.append('primaryGroupId', params.primaryGroupId);
    if (params.secondaryGroupId) queryParams.append('secondaryGroupId', params.secondaryGroupId);
    if (params.mac) queryParams.append('mac', params.mac);
    if (params.branchIds){
        params.branchIds.forEach(id => {
          queryParams.append("branchIds", id);
        });
    }

    const queryString = queryParams.toString();
    const url = `/analysis/energy-matrix/summary${queryString ? `?${queryString}` : ''}`;

    const response = await publicRequest.get(url, {
      headers: { token: `Bearer ${token}` },
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching energy matrix summary:', error);
    throw error;
  }
};
